import React from 'react';
import { Phone, Pencil } from 'lucide-react';

/**
 * CallCategoryTabs - Category filter tabs for calls with edit and new call buttons
 */
const CallCategoryTabs = ({
  categories = [],
  activeCategory,
  onCategoryChange,
  onEditCategories,
  onNewCall,
  formatCategoryName,
  className = ''
}) => {
  return (
    <div className={`flex flex-col sm:flex-row gap-2 p-3 md:p-4 bg-black border-b border-gray-400/20 items-start sm:items-center justify-between ${className}`}>
      <div className="flex gap-1 md:gap-2 overflow-x-auto w-full sm:w-auto pb-2 sm:pb-0 items-center">
        <button
          onClick={() => onCategoryChange?.('all')}
          className={`flex-shrink-0 px-2 md:px-4 py-1.5 md:py-2 rounded-lg transition-colors text-xs md:text-sm font-medium whitespace-nowrap ${
            activeCategory === 'all'
              ? 'bg-white text-black'
              : 'text-gray-400 hover:bg-gray-900'
          }`}
          data-testid="call-category-all-btn"
        >
          All
        </button>
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => onCategoryChange?.(cat)}
            data-testid={`call-category-${cat}-btn`}
            className={`flex-shrink-0 px-2 md:px-4 py-1.5 md:py-2 rounded-lg transition-colors text-xs md:text-sm font-medium whitespace-nowrap ${
              activeCategory === cat
                ? 'bg-white text-black'
                : 'text-gray-400 hover:bg-gray-900'
            }`}
          >
            {formatCategoryName ? formatCategoryName(cat) : cat}
          </button>
        ))}
        {/* Edit Categories Button */}
        <button
          onClick={onEditCategories}
          data-testid="edit-call-categories-btn"
          className="flex-shrink-0 px-2 py-1.5 md:py-2 rounded-lg text-xs font-medium transition-all whitespace-nowrap text-gray-500 hover:bg-gray-900 hover:text-gray-300 border border-dashed border-gray-700"
          title="Edit Categories"
        >
          <Pencil size={12} className="inline mr-1" />
          Edit
        </button>
      </div>
      
      {/* New Call Button */}
      <button
        onClick={onNewCall}
        className="px-3 md:px-4 py-1.5 md:py-2 bg-white hover:bg-gray-200 rounded-lg transition-colors flex items-center gap-1.5 md:gap-2 text-black font-medium text-xs md:text-sm flex-shrink-0"
        title="New call"
        data-testid="new-call-btn"
      >
        <Phone size={14} />
        <span className="hidden sm:inline">New Call</span>
        <span className="sm:hidden">Call</span>
      </button>
    </div>
  );
};

export default CallCategoryTabs;
